import React from 'react';
import { motion } from 'framer-motion';
import { Route, Phone, FileText, ClipboardCheck } from 'lucide-react';
const CARDS = [{
  icon: Route,
  title: 'Load Planning',
  desc: 'Plan the week, not just the next load. FSG helps line up freight so one load leads into the next and RPM stays protected where possible.'
}, {
  icon: Phone,
  title: 'Broker Communication',
  desc: 'FSG handles broker updates, setup requests, call follow-up, and rate conversations so drivers are not buried in phone calls.'
}, {
  icon: FileText,
  title: 'Paperwork and Billing',
  desc: 'FSG helps keep documents, billing, rate cons, and load paperwork organized so money does not get stuck because paperwork is missing.'
}, {
  icon: ClipboardCheck,
  title: 'Verification and Compliance Support',
  desc: 'FSG helps with broker verification, carrier profile setup, documentation, and compliance-related handoffs where appropriate.'
}];
export function CoreSupport() {
  return <section id="back-office" className="section-padding bg-navy text-white" data-id="element-127">
      <div className="container-custom" data-id="element-128">
        <div className="max-w-3xl mb-8" data-id="element-129">
          <span className="eyebrow !text-amber" data-id="element-130">Core Support</span>
          <h2 className="text-3xl md:text-4xl font-black text-white tracking-tight" data-id="element-131">
            Everything That Keeps a Truck Earning
          </h2>
        </div>

        {/* Dispatch-to-cash workflow accent */}
        <div className="hidden md:flex justify-center my-6" data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/uPAdhSnYURLwhw86YmBuvu/fsg-dispatch-workflow-strip.svg" alt="Dispatch-to-cash workflow route graphic" className="w-full max-w-[1000px] h-auto" data-id="element-133" />
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-134">
          {CARDS.map((card, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-black/40 border border-white/10 rounded-sm p-8 flex gap-5 h-full" data-id="element-135">
              <div className="w-12 h-12 bg-white/5 border border-white/10 rounded-sm flex items-center justify-center shrink-0" data-id="element-136">
                <card.icon className="w-6 h-6 text-amber" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-139">
                  {card.title}
                </h3>
                <p className="text-off-white/70 font-medium leading-relaxed" data-id="element-140">
                  {card.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}